import { render } from "./About.vue?vue&type=template&id=07628072&scoped=true"
const script = {}

import "@/assets/styles/text-page.scss?vue&type=style&index=0&id=07628072&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-07628072"

export default script